import { createAction, createApiAction } from 'store';
import * as types from './ActionTypes';
import {
	POST_NEW_USER,
	RESET_USER_FORM_DATA,
	RESET_IS_PARTNER_DELETED,
} from './ActionTypes';

export const getPartnerList = createApiAction(types.GET_PARTNER_LIST);
export const updatePartnerList = createApiAction(types.UPDATE_PARTNER_LIST);

export const postNewPartner = createApiAction(types.POST_NEW_PARTNER);
export const deletePartner = createApiAction(types.DELETE_PARTNER);

export const resetError = createAction(types.RESET_ERROR);

export const getPartnerDetails = createApiAction(types.GET_PARTNER_DETAILS);

export const getPartnerData = createApiAction(types.GET_PARTNER_DATA);
export const updatePartnerData = createApiAction(types.UPDATE_PARTNER_DATA);

export const getPartnerAdmins = createApiAction(types.GET_PARTNER_ADMINS);
export const getPartnerClients = createApiAction(types.GET_PARTNER_CLIENTS);

export const resetPartners = createAction(types.RESET_PARTNER_LIST);
export const resetNewPartner = createAction(types.RESET_NEW_PARTNER);
export const resetPartnerData = createAction(types.RESET_PARTNER_DATA);
export const resetUpdatePartnerData = createAction(
	types.RESET_UPDATE_PARTNER_DATA,
);

export const createNewUser = createApiAction(POST_NEW_USER);
export const resetNewUser = createAction(RESET_USER_FORM_DATA);
export const resetIsPartnerDeleted = createAction(RESET_IS_PARTNER_DELETED);
